import { Trophy, ShieldCheck, Wrench, Award } from "lucide-react";
import MotionReveal from "../common/MotionReveal/MotionReveal";
import MotionStagger from "../common/Motion/MotionStagger";
import MotionItem from "../common/Motion/MotionItem";
import HoverCard from "../common/Motion/HoverCard";

const MILESTONES = [
  {
    year: "2022",
    icon: Trophy,
    tag: "Best Performing Offshore Rig",
    title: "Rig Sagar Shakti",
    line: "Honored by the Chairman of ONGC at Goa for exceptional offshore operations & maintenance performance.",
  },
  {
    year: "2023",
    icon: ShieldCheck,
    tag: "Best Offshore Rig & Best HSE Award",
    title: "Rig Sagar Shakti",
    line: "Consecutive recognition for operational and offshore performance excellence.",
  },
  {
    year: "2023",
    icon: Award,
    tag: "Best Performing Drilling Rig — Cambay Asset",
    title: "Drilling Rig CW-IX",
    line: "Awarded by the Chairman of ONGC at Dehradun.",
  },
  {
    year: "2025",
    icon: ShieldCheck,
    tag: "Best Offshore Rig & Best HSE Award",
    title: "Rig Sagar Gaurav",
    line: "Recognized for consistently exceeding annual offshore operational targets.",
  },
  {
    year: "2025",
    icon: Wrench,
    tag: "Best Performing Workover Rig",
    title: "Workover Rig ROM 9",
    line: "Recognized for outstanding workover operational performance across ONGC assets.",
  },
  {
    year: "2025",
    icon: Trophy,
    tag: "Best Performing Onshore Rig",
    title: "Rig Saksham M490",
    line: "Recognized for exceptional onshore drilling performance during the current operational year.",
  },
];

function IndustryRecognitions() {
  return (
    <section className="relative overflow-hidden bg-[#071A2F] py-16 lg:py-20">
      <div className="absolute inset-0 bg-[#071A2F]/95" aria-hidden="true" />

      <div
        className="absolute top-0 left-0 h-96 w-96 bg-red-500/10 blur-[140px]"
        aria-hidden="true"
      />
      <div
        className="absolute bottom-0 right-0 h-96 w-96 bg-red-500/10 blur-[140px]"
        aria-hidden="true"
      />

      <div
        className="pointer-events-none absolute top-16 left-1/2 -translate-x-1/2 select-none"
        aria-hidden="true"
      >
        <p className="text-[72px] font-black tracking-[0.18em] text-white/[0.05] sm:text-[100px] lg:text-[140px]">
          HONORS
        </p>
      </div>

      <div className="relative mx-auto max-w-7xl px-6 z-10">
        <MotionReveal variant="fadeUp" className="mx-auto max-w-3xl text-center">
          <span className="text-sm font-semibold uppercase tracking-[0.3em] text-red-500">
            Recognitions & Milestones
          </span>

          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-[1.12] tracking-tight">
            Industry Recognitions
          </h2>

          <div className="mx-auto mt-8 h-px w-16 bg-red-500" aria-hidden="true" />

          <p className="mt-8 text-base sm:text-lg text-slate-300 leading-relaxed">
            Official recognitions honoring operational performance excellence
            across offshore, onshore and workover assets supported by South
            Asia Consultancy teams.
          </p>
        </MotionReveal>

        <MotionStagger className="mt-16 lg:mt-20 space-y-4">
          {MILESTONES.map((item, index) => {
            const Icon = item.icon;

            return (
              <MotionItem key={`${item.title}-${item.year}`} variant="fadeLeft">
                <HoverCard className="group flex items-start gap-5 border border-white/10 bg-white/[0.03] px-6 py-5 transition-colors duration-300 hover:border-red-500/30 hover:bg-white/[0.06]">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-400 transition-transform duration-300 group-hover:scale-105">
                    <Icon size={20} aria-hidden="true" />
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-baseline justify-between gap-3">
                      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                        {item.year} · {String(index + 1).padStart(2, "0")}
                      </span>
                      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-red-500">
                        {item.tag}
                      </span>
                    </div>

                    <p className="mt-1 text-base sm:text-lg font-medium text-white leading-relaxed">
                      {item.title}
                    </p>
                    <p className="mt-1 text-sm sm:text-base text-slate-300 leading-relaxed">
                      {item.line}
                    </p>
                  </div>
                </HoverCard>
              </MotionItem>
            );
          })}
        </MotionStagger>

        <MotionReveal variant="fadeUp" className="mt-16 lg:mt-20 max-w-5xl mx-auto">
          <div className="border-l-2 border-red-500 pl-8">
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed text-justify">
              These milestones reflect SAC's sustained operational discipline
              across offshore, onshore and workover assets — recognized
              directly by ONGC leadership for performance, safety and
              reliability year over year.
            </p>
          </div>
        </MotionReveal>
      </div>
    </section>
  );
}

export default IndustryRecognitions;